module.exports = __webpack_public_path__ + "img/selected6-min.187ba3d6.png";